import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

// Define a type for the slice state
interface authState {
    phone: string;
    isLoggedIn: boolean;
    token: string;
}

// Define the initial state using that type
const initialState: authState = {
    phone: '',
    isLoggedIn: false,
    token: ''
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        saveAuthInfo: (state, action: PayloadAction<authState>) => {
            state.phone = action.payload.phone;
            state.isLoggedIn = action.payload.isLoggedIn;
            state.token = action.payload.token;
        }
    }
});

// Action creators are generated for each case reducer function
export const { saveAuthInfo } = authSlice.actions;

export default authSlice.reducer;
